import { render, staticRenderFns } from "./text-line.vue?vue&type=template&id=1dfa1c62&scoped=true&"
import script from "./text-line.vue?vue&type=script&lang=ts&"
export * from "./text-line.vue?vue&type=script&lang=ts&"
import style0 from "./text-line.vue?vue&type=style&index=0&id=1dfa1c62&lang=scss&scoped=true&"
import style1 from "./text-line.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa1c62",
  null
  
)

export default component.exports